var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPogodnostiStatusa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1310",
    "data-name": "Group 1310",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 28,
    height: 24,
    fill: "#004c97"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 7,
    height: 2,
    transform: "translate(11 7)",
    fill: "#004c97"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M27,9H24.98A5.78,5.78,0,0,0,23,4.852V1A1,1,0,0,0,21.4.2L17.667,3H13C7.49,3,3.537,6.241,3.051,11H3a1,1,0,0,1-1-1V8H0v2a3,3,0,0,0,3,3h.07A9.175,9.175,0,0,0,7,19.557V23a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V21h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V19.637A5.091,5.091,0,0,0,24.819,16H27a1,1,0,0,0,1-1V10a1,1,0,0,0-1-1m-1,5H23.124c-.305,2.753-.823,3.485-3.124,4.315V22H18V19H11v3H9V18.378A7.013,7.013,0,0,1,5,12c0-4.835,4.018-7,8-7h5.333L21,3V5.776c2.418,1.86,1.913,3.186,2.018,5.224H26Z",
    fill: "#004c97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPogodnostiStatusa);
export default __webpack_public_path__ + "static/media/pogodnosti_statusa.8ee7f3576fdda2c8cbc7fe8b8a911491.svg";
export { ForwardRef as ReactComponent };